import { useEffect, useState } from "react";
import { Box, Button, Dialog, DialogContent, IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import QRCode from "react-qr-code";
import BuildIdLogo from "../../assets/images/build_id_logo.png";

const ViewTicketsWithQR = ({ open, handleClose, loginData }) => {
  const [qrCodeValue, setQrCodeValue] = useState("");

  useEffect(() => {
    if (loginData?.userInformation?.UserId) {
      const value = `${import.meta.env.REACT_APP_WEB_USER}/user-tickets/${
        loginData.userInformation.UserId
      }`;
      setQrCodeValue(value);
    }
  }, [loginData]);

  const downloadQRCode = () => {
    const svg = document.getElementById("ticket-qr-code");

    const serializer = new XMLSerializer();
    const svgData = serializer.serializeToString(svg);

    const qrImage = new Image();
    qrImage.src = "data:image/svg+xml;base64," + window.btoa(unescape(encodeURIComponent(svgData)));

    const logo = new Image();
    logo.src = BuildIdLogo; // your logo path

    Promise.all([
      new Promise((resolve) => {
        qrImage.onload = resolve;
      }),
      new Promise((resolve) => {
        logo.onload = resolve;
      })
    ]).then(() => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = 700;
      canvas.height = 850;

      // Background
      ctx.fillStyle = "#f5f5f5";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Logo
      const logoWidth = 250;
      const logoHeight = 90;

      ctx.drawImage(logo, (canvas.width - logoWidth) / 2, 50, logoWidth, logoHeight);

      // Rounded Card
      const cardX = 75;
      const cardY = 180;
      const cardSize = 550;
      const radius = 25;

      ctx.fillStyle = "#ffffff";
      ctx.strokeStyle = "#d9d9d9";
      ctx.lineWidth = 2;

      ctx.beginPath();
      ctx.moveTo(cardX + radius, cardY);
      ctx.lineTo(cardX + cardSize - radius, cardY);
      ctx.quadraticCurveTo(cardX + cardSize, cardY, cardX + cardSize, cardY + radius);
      ctx.lineTo(cardX + cardSize, cardY + cardSize - radius);
      ctx.quadraticCurveTo(
        cardX + cardSize,
        cardY + cardSize,
        cardX + cardSize - radius,
        cardY + cardSize
      );
      ctx.lineTo(cardX + radius, cardY + cardSize);
      ctx.quadraticCurveTo(cardX, cardY + cardSize, cardX, cardY + cardSize - radius);
      ctx.lineTo(cardX, cardY + radius);
      ctx.quadraticCurveTo(cardX, cardY, cardX + radius, cardY);
      ctx.closePath();

      ctx.fill();
      ctx.stroke();

      // QR Code
      ctx.drawImage(qrImage, cardX + 30, cardY + 30, cardSize - 60, cardSize - 60);

      // Download
      const link = document.createElement("a");
      link.download = "buildid-qr-code.png";
      link.href = canvas.toDataURL("image/png");
      link.click();
    });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          p: 1
        }
      }}>
      <DialogContent>
        <Stack spacing={1.5} sx={{ alignItems: "center" }}>
          <Box
            sx={{
              width: 50,
              height: 5,
              borderRadius: 10,
              bgcolor: "#d9d9d9"
            }}
          />

          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 16,
              top: 16
            }}>
            <CloseIcon />
          </IconButton>

          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Share Your Tickets
          </Typography>

          <Typography variant="body2" sx={{ color: "text.secondary" }} textAlign="center">
            Share this QR code with your supervisor or employer. When they scan it, they will send
            you an access request. you can approve or decline it before they can view your tickets.
          </Typography>

          <Box
            sx={{
              p: 2,
              bgcolor: "#fff",
              borderRadius: 4,
              boxShadow: "0 4px 20px rgba(0,0,0,0.12)"
            }}>
            {qrCodeValue && (
              <QRCode
                id="ticket-qr-code"
                value={qrCodeValue}
                size={180}
                style={{
                  width: "100%",
                  height: "auto"
                }}
              />
            )}
          </Box>

          <Typography variant="caption" sx={{ color: "text.secondary" }} textAlign="center">
            Your tickets are only shared after you approve the request.
          </Typography>

          <Button
            fullWidth
            variant="contained"
            onClick={downloadQRCode}
            sx={{
              borderRadius: 3,
              textTransform: "none",
              fontSize: "15px"
            }}>
            Download QR Code
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default ViewTicketsWithQR;
